import { NavLink } from 'react-router-dom';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from '@mui/material';
import { useStoreContext } from 'store';
import { MenuNavLink } from 'routes/links';
import { activeLinkItemMixin } from './mixins';

interface Props {
  links: MenuNavLink[];
  isOpen?: boolean;
}

const NavLinks = (props: Props): JSX.Element => {
  const { links, isOpen } = props;
  const {
    state: { isSideNavOpen },
  } = useStoreContext();
  const open = typeof isOpen === 'boolean' ? isOpen : isSideNavOpen;

  return (
    <>
      {links.map(({ Icon, ...link }) => (
        <ListItem key={link.link} disablePadding sx={{ display: 'block' }}>
          <ListItemButton
            component={NavLink}
            to={link.link}
            sx={(theme) => activeLinkItemMixin(theme)}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 3 : 'auto',
                justifyContent: 'center',
              }}
            >
              <Icon />
            </ListItemIcon>
            <ListItemText primary={link.name} sx={{ opacity: open ? 1 : 0 }} />
          </ListItemButton>
        </ListItem>
      ))}
    </>
  );
};

export default NavLinks;
